import { DbCrudHelper, RowsAffected } from "@app/shared/services/db-crud-helper";
import { Observable, map } from "rxjs";
import { ProjectView, ProjectViewData, ProjectViewHelper } from "../model/project-view";

import { Injectable } from "@angular/core";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";

@Injectable({
    providedIn: "root",
})
export class ProjectViewDbService {
    helper = new ProjectViewHelper();
    crudHelperService: ClareWSCrudHelperService<ProjectView, ProjectViewData>;
    /**
     * @param websocketService app websocket
     * @param databaseService database service
     * @param tsLoggingService logging
     * @param crudHelper
     */
    constructor(protected tsLoggingService: TSLoggingService, protected crudHelper: DbCrudHelper) {
        this.crudHelperService = new ClareWSCrudHelperService(tsLoggingService, crudHelper, this.helper);
    }

    /**
     * @description getting project view
     * @param entityId entity id
     * @param userId user id
     * @returns {Observable<ClareDbCollection<ProjectView>>} project view list
     */
    getProjectViewForUserOrEntity(entityId: number, userId: number): Observable<ClareDbCollection<ProjectView>> {
        return this.crudHelperService
            .retrieve({
                endpoint: "GetProjectViewForUserOrEntity",
                data: {
                    entity_id: entityId,
                    userinfo_id: userId,
                },
            })
            .pipe(
                map(data => {
                    if (!data) {
                        return {};
                    }
                    return data.reduce(
                        (accumulator, currentValue) => ({
                            ...accumulator,
                            [currentValue.id]: this.helper.fromDbObject(currentValue),
                        }),
                        {} as Record<number, ProjectView>
                    );
                })
            );
    }

    /**
     *
     * @param projectView new project view data
     * @returns { Observable<ProjectView | null> } project view data if saving successfully
     */
    createProjectView(projectView: ProjectView): Observable<ProjectView | null> {
        return this.crudHelperService
            .create({
                endpoint: "CreateProjectView",
                data: projectView,
                logData: { projectView },
            })
            .pipe(map(result => this.helper.fromDbObject(result)));
    }

    /**
     *
     * @param projectView new project view data
     * @returns { Observable<ProjectView | null> } project view data if saving successfully
     */
    updateProjectView(projectView: ProjectView): Observable<RowsAffected> {
        return this.crudHelperService.update({
            endpoint: "UpdateProjectView",
            data: projectView,
            logData: { projectView },
        });
    }

    /**
     * @description deleting project view
     * @param projectView new project view data
     * @returns { Observable<ProjectView | null> } project view data if saving successfully
     */
    deleteProjectView(projectView: ProjectView): Observable<RowsAffected> {
        return this.crudHelperService.delete({
            endpoint: "DeleteProjectView",
            id: projectView.id,
            logData: { projectView },
        });
    }
}
